<template>
  <cobrand>
    <div :class="cssClass" :style="'background-color:#'+bgColor+' !important;'">
      <LayoutBase :gtm="false">
        </LayoutBase>
      <div id="app">
        <slot />
      </div>
      <div class="secondary-logo"></div>
    </div>
  </cobrand>
</template>

<script>
import Cobrand from '~/components/Cobrand'
import LayoutBase from './base'

export default {
  home () {
    return {
      meta: [{ name: 'robots', content: 'noindex' }]
    }
  },
  data () {
    return {
      cssClass: 'bg-white',
      bgColor: 'background-color:white;'
    }
  },
  mounted: function () {
    if(useRoute().query.class) {
      this.cssClass = useRoute().query.class;
    }
    if(useRoute().query.color) {
      this.bgColor = useRoute().query.color;
    }
  },
  components: {
    Cobrand,
    LayoutBase
  }
}
</script>

<style lang="scss" scoped>

.bg-white {
  background: #fff;
  height: auto;
  min-height: 1200px;
}
.bg-dark {
  height: auto;
  min-height: 1200px;
  color: #fff;
}
#cookie-header {
  display: none !important;
  visibility: hidden !important;
}
</style>
